import { useCoverEditor } from '@papan/core-ui/ui'
import { useTranslation } from '@papan/i18n'

/**
 * #929/#930 — report the conflict view's "Saved version" panel as a COVER over the live editor (see EditorCover in
 * core-ui). Every surface that shows it while the live editor stays mounted underneath calls this: the office editors
 * (OnlyOffice — what every environment runs — and the Collabora fallbacks) hide the live editor `display:none`, the
 * text editors' ConflictOverlay lays the saved copy `absolute inset-0` over it.
 *
 * The host then greys out the editor's own commands and refuses Save — which would write the hidden live document —
 * with a notice whose action goes back to "Your changes". Refused, not applied: keeping your changes over the saved
 * file is the banner's explicit "Keep my changes".
 */
export function useSavedVersionCover(showSavedVersion: boolean, backToYourChanges: () => void): void {
  const { t } = useTranslation('collab')
  useCoverEditor(showSavedVersion ? {
    message: t('conflict.saveBlocked'),
    actionLabel: t('conflict.showYourChanges'),
    uncover: backToYourChanges,
  } : null)
}
